import PeopleIcon from '@mui/icons-material/People';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import EventIcon from '@mui/icons-material/Event';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DescriptionIcon from '@mui/icons-material/Description';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AssessmentIcon from '@mui/icons-material/Assessment';
import EmailIcon from '@mui/icons-material/Email';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import { NotificationsActive, Visibility, Widgets } from '@mui/icons-material';

export const featuresData = [
  {
    slug: 'uye-yonetimi',
    icon: PeopleIcon,
    title: 'Üye Yönetimi',
    shortDesc: 'Üyelerinizi kolayca kaydedin, güncelleyin ve yönetin.',
    color: '#03c0ff',
    heroDesc: 'Derneğinizin en değerli varlığı üyelerinizdir. Üye yönetim sistemimiz ile tüm üye bilgilerini tek bir merkezden yönetin, takip edin ve analiz edin.',
    benefits: [
      'Sınırsız üye kaydı ve profil yönetimi',
      'Üye kartı oluşturma ve QR kod entegrasyonu',
      'Üyelik türlerine göre kategorilendirme',
      'Detaylı üye arama ve filtreleme',
      'Üye geçmişi ve aktivite takibi',
      'Toplu üye import/export (Excel, CSV)',
    ],
    details: [
      {
        title: 'Kapsamlı Üye Profilleri',
        desc: 'Her üye için detaylı profil oluşturun. İletişim bilgileri, üyelik geçmişi, ödeme durumu ve özel notlar tek ekranda.',
      },
      {
        title: 'Akıllı Arama & Filtreleme',
        desc: 'İsim, üyelik tipi, kayıt tarihi veya özel alanlara göre anında arama yapın. Gelişmiş filtrelerle istediğiniz üye grubuna ulaşın.',
      },
      {
        title: 'Üyelik Durumu Takibi',
        desc: 'Aktif, pasif, beklemede veya özel durumları takip edin. Otomatik durum güncellemeleri ile her şey kontrol altında.',
      },
    ],
    image: '/assets/features/page_images/uye-yonetimi.webp',
  },
  {
    slug: 'aidat-takibi',
    icon: CreditCardIcon,
    title: 'Aidat Takibi',
    shortDesc: 'Aidat ödemelerini takip edin, otomatik hatırlatmalar gönderin.',
    color: '#fc8d05',
    heroDesc: 'Aidat tahsilatı artık sorun değil. Otomatik hatırlatmalar, çoklu ödeme yöntemleri ve detaylı raporlarla aidat yönetimini kolaylaştırın.',
    benefits: [
      'Otomatik aidat hatırlatmaları (SMS/E-posta)',
      'Online ödeme entegrasyonu',
      'Taksitli ödeme planları',
      'Gecikme faizi hesaplama',
      'Makbuz ve dekont oluşturma',
      'Ödeme geçmişi raporlama',
    ],
    details: [
      {
        title: 'Çoklu Ödeme Yöntemleri',
        desc: 'Kredi kartı, havale/EFT, kapıda ödeme ve online ödeme seçenekleri. Üyelerinize esneklik sunun.',
      },
      {
        title: 'Otomatik Hatırlatmalar',
        desc: 'Ödeme vadesi yaklaşan veya geciken üyelere otomatik SMS ve e-posta gönderimi. Manuel takip yükünden kurtulun.',
      },
      {
        title: 'Detaylı Ödeme Raporları',
        desc: 'Aylık, yıllık ve dönemsel aidat raporları. Tahsilat oranları, gecikme analizleri ve trend grafikleri.',
      },
    ],
    image: '/assets/features/aidat-takibi.png',
  },
  {
    slug: 'etkinlik-yonetimi',
    icon: EventIcon,
    title: 'Etkinlik Yönetimi',
    shortDesc: 'Etkinliklerinizi planlayın ve katılımcıları kolayca yönetin.',
    color: '#10b981',
    heroDesc: 'Seminerden toplantıya, geziden kursa tüm etkinliklerinizi tek platformda planlayın, duyurun ve yönetin.',
    benefits: [
      'Etkinlik takvimi ve planlama',
      'Online kayıt ve katılım takibi',
      'QR kodlu giriş sistemi',
      'Etkinlik duyuru otomasyonu',
      'Katılımcı listesi yönetimi',
      'Etkinlik sonrası anket ve geri bildirim',
    ],
    details: [
      {
        title: 'Kolay Etkinlik Oluşturma',
        desc: 'Birkaç tıkla etkinlik oluşturun. Tarih, saat, konum, kontenjan ve katılım ücreti ayarları.',
      },
      {
        title: 'Online Kayıt Sistemi',
        desc: 'Üyeler web sitesi veya mobil uygulama üzerinden etkinliklere kayıt olabilir. Kontenjan kontrolü otomatik.',
      },
      {
        title: 'Katılım Takibi',
        desc: 'QR kod okutma ile hızlı giriş. Gerçek zamanlı katılım listesi ve devamsızlık raporları.',
      },
    ],
    image: '/assets/features/etkinlik-yonetimi.png',
  },
  {
    slug: 'finansal-yonetim',
    icon: AccountBalanceIcon,
    title: 'Finansal Yönetim',
    shortDesc: 'Gelir-gider takibi ve detaylı finansal raporlama.',
    color: '#8b5cf6',
    heroDesc: 'Derneğinizin finansal sağlığını kontrol altında tutun. Gelir-gider takibi, bütçe planlama ve şeffaf raporlama ile mali yönetim artık kolay.',
    benefits: [
      'Gelir-gider kaydı ve kategorilendirme',
      'Bütçe planlama ve takibi',
      'Banka hesap entegrasyonu',
      'Fatura ve makbuz yönetimi',
      'Mali tablo ve bilanço raporları',
      'Denetim için hazır raporlar',
    ],
    details: [
      {
        title: 'Kapsamlı Gelir-Gider Takibi',
        desc: 'Tüm finansal hareketleri kategorize edin. Aidat, bağış, sponsor gelirleri ve tüm giderleri tek ekranda izleyin.',
      },
      {
        title: 'Bütçe Planlama',
        desc: 'Yıllık ve dönemsel bütçe oluşturun. Gerçekleşen ile planlanan karşılaştırması yapın.',
      },
      {
        title: 'Şeffaf Raporlama',
        desc: 'Yönetim kurulu ve üyeler için anlaşılır finansal raporlar. Denetim süreçleri için hazır dokümanlar.',
      },
    ],
    image: '/assets/features/finansal-yonetim.png',
  },
  {
    slug: 'belge-yonetimi',
    icon: DescriptionIcon,
    title: 'Belge Yönetimi',
    shortDesc: 'Evraklarınızı güvenli bulutta saklayın ve hızlıca erişin.',
    color: '#06b6d4',
    heroDesc: 'Tüm dernek belgelerini dijital ortamda güvenle saklayın. Kolay erişim, versiyon kontrolü ve paylaşım özellikleri ile belge yönetimini modernleştirin.',
    benefits: [
      'Bulut tabanlı güvenli depolama',
      'Klasör ve etiket sistemi',
      'Versiyon kontrolü',
      'Belge arama ve filtreleme',
      'Paylaşım ve erişim yetkileri',
      'Otomatik yedekleme',
    ],
    details: [
      {
        title: 'Organize Dosya Sistemi',
        desc: 'Klasörler, etiketler ve kategorilerle belgelerinizi düzenleyin. İstediğinize saniyeler içinde ulaşın.',
      },
      {
        title: 'Güvenli Depolama',
        desc: 'SSL şifreleme ve düzenli yedekleme ile belgeleriniz güvende. KVKK uyumlu altyapı.',
      },
      {
        title: 'Kolay Paylaşım',
        desc: 'Belgeleri üyeler veya yönetim kurulu ile güvenli şekilde paylaşın. Erişim izinlerini detaylı ayarlayın.',
      },
    ],
    image: '/assets/features/belge-yonetimi.png',
  },
  {
    slug: 'rol-yonetimi',
    icon: AdminPanelSettingsIcon,
    title: 'Rol Yönetimi',
    shortDesc: 'Kullanıcı yetkilerini detaylı olarak belirleyin.',
    color: '#f43f5e',
    heroDesc: 'Her kullanıcıya ihtiyacı kadar yetki verin. Esnek rol sistemi ile güvenliği artırın, operasyonel verimliliği maksimize edin.',
    benefits: [
      'Özelleştirilebilir roller',
      'Modül bazlı yetkilendirme',
      'Kullanıcı grubu yönetimi',
      'İşlem logları ve denetim',
      'İki faktörlü kimlik doğrulama',
      'Oturum yönetimi',
    ],
    details: [
      {
        title: 'Esnek Rol Sistemi',
        desc: 'Yönetici, muhasebeci, sekreter veya özel roller tanımlayın. Her role farklı yetkiler atayın.',
      },
      {
        title: 'Modül Bazlı Erişim',
        desc: 'Üye yönetimi, finans, etkinlik gibi modüllere ayrı ayrı erişim izni verin.',
      },
      {
        title: 'Güvenlik & Denetim',
        desc: 'Tüm işlemler loglanır. Kim, ne zaman, ne yaptı sorularının cevabı her zaman elinizde.',
      },
    ],
    image: '/assets/features/rol-yonetimi.png',
  },
  {
    slug: 'raporlama',
    icon: AssessmentIcon,
    title: 'Raporlama',
    shortDesc: 'Detaylı raporlar ile derneğinizin performansını analiz edin.',
    color: '#0ea5e9',
    heroDesc: 'Veriye dayalı kararlar alın. Kapsamlı raporlama araçları ile derneğinizin tüm faaliyetlerini analiz edin ve görselleştirin.',
    benefits: [
      'Hazır rapor şablonları',
      'Özel rapor oluşturma',
      'Görsel grafikler ve dashboardlar',
      'Excel ve PDF export',
      'Otomatik rapor gönderimi',
      'Karşılaştırmalı analizler',
    ],
    details: [
      {
        title: 'Kapsamlı Dashboard',
        desc: 'Üye sayıları, aidat tahsilat oranları, etkinlik katılımları ve finansal özet tek bakışta.',
      },
      {
        title: 'Özelleştirilebilir Raporlar',
        desc: 'İhtiyacınıza göre özel raporlar oluşturun. Filtreleme, gruplama ve sıralama seçenekleri.',
      },
      {
        title: 'Otomatik Raporlama',
        desc: 'Haftalık veya aylık raporları otomatik olarak e-posta ile alın. Yönetim kurulunu bilgilendirin.',
      },
    ],
    image: '/assets/features/raporlama.png',
  },
  {
    slug: 'iletisim-araclari',
    icon: EmailIcon,
    title: 'İletişim Araçları',
    shortDesc: 'Toplu e-posta ve SMS ile üyelerinizle iletişim kurun.',
    color: '#ec4899',
    heroDesc: 'Üyelerinizle güçlü iletişim kurun. Toplu mesaj gönderimi, duyuru sistemi ve bildirimlerle her zaman bağlantıda kalın.',
    benefits: [
      'Toplu e-posta gönderimi',
      'SMS entegrasyonu',
      'Push bildirimler',
      'E-posta şablonları',
      'Gönderim raporları',
      'Segmentasyon ve hedefleme',
    ],
    details: [
      {
        title: 'Çoklu Kanal İletişim',
        desc: 'E-posta, SMS ve push bildirim ile üyelerinize ulaşın. Her kanal için ayrı içerik oluşturun.',
      },
      {
        title: 'Akıllı Segmentasyon',
        desc: 'Üyeleri gruplara ayırın ve hedefli mesajlar gönderin. Üyelik tipi, şehir veya özel kriterlere göre.',
      },
      {
        title: 'Şablon Sistemi',
        desc: 'Sık kullanılan mesajlar için şablonlar oluşturun. Kişiselleştirme alanları ile dinamik içerik.',
      },
    ],
    image: '/assets/features/iletisim-araclari.png',
  },
  {
    slug: 'mobil-uygulama',
    icon: SmartphoneIcon,
    title: 'Mobil Uygulama',
    shortDesc: 'iOS ve Android uygulamalarıyla her yerden erişim.',
    color: '#14b8a6',
    heroDesc: 'Derneğiniz artık cebinizde. Üyeleriniz mobil uygulama ile bilgilere erişebilir, aidat ödeyebilir ve etkinliklere katılabilir.',
    benefits: [
      'iOS ve Android uygulamaları',
      'Üye girişi ve profil yönetimi',
      'Mobil aidat ödeme',
      'Etkinlik takvimi ve kayıt',
      'Push bildirimler',
      'Dijital üye kartı',
    ],
    details: [
      {
        title: 'Üye Deneyimi',
        desc: 'Üyeler kendi bilgilerini görüntüleyebilir, aidat durumunu kontrol edebilir ve ödeme yapabilir.',
      },
      {
        title: 'Etkinlik Erişimi',
        desc: 'Yaklaşan etkinlikleri görün, kayıt olun ve QR kodlu giriş yapın.',
      },
      {
        title: 'Anlık Bildirimler',
        desc: 'Önemli duyurular, aidat hatırlatmaları ve etkinlik bildirimleri anında telefonunuzda.',
      },
    ],
    image: '/assets/features/mobil-uygulama.png',
  },
  {
    slug: 'widget-sistemi',
    icon: Widgets,
    title: 'Widget Sistemi',
    shortDesc: 'Web sitenizi sürükle-bırak widgetlar ile yönetin.',
    color: '#f59e0b',
    heroDesc: 'Kod yazmadan profesyonel web sayfaları oluşturun. Sürükle-bırak widget sistemi ile web sitenizi ve dashboard ekranınızı tamamen özelleştirin.',
    benefits: [
      'Sürükle-bırak arayüzü',
      'Hazır widget kütüphanesi',
      'Responsive tasarım',
      'Canlı önizleme',
      'Header ve footer özelleştirme',
      'Dashboard widget yönetimi',
    ],
    details: [
      {
        title: 'Kolay Sayfa Tasarımı',
        desc: 'Widgetları sürükleyip bırakın, içerikleri düzenleyin ve anında yayınlayın. Teknik bilgi gerektirmez.',
      },
      {
        title: 'Zengin Widget Seçenekleri',
        desc: 'Duyuru, etkinlik, bağış formu, galeri ve daha fazlası. İhtiyacınıza uygun widget seçin.',
      },
      {
        title: 'Tam Kontrol',
        desc: 'Header, footer ve tüm sayfaları özelleştirin. Derneğinizin kimliğini yansıtan tasarımlar oluşturun.',
      },
    ],
    image: '/assets/features/widget-sistemi.png',
  },
  {
    slug: 'seffaflik',
    icon: Visibility,
    title: 'Şeffaflık',
    shortDesc: 'Yönetim süreçlerini kayıt altına alın, şeffaf yapı kurun.',
    color: '#6366f1',
    heroDesc: 'Güven şeffaflıkla başlar. Tüm yönetim süreçlerini kayıt altına alın, üyelerinize hesap verebilir bir yapı sunun.',
    benefits: [
      'İşlem geçmişi ve loglar',
      'Karar ve toplantı kayıtları',
      'Üyelere açık raporlar',
      'Denetim kolaylığı',
      'Değişiklik takibi',
      'Onay akışları',
    ],
    details: [
      {
        title: 'Tam İzlenebilirlik',
        desc: 'Her işlem, her değişiklik kayıt altında. Kim, ne zaman, ne yaptı sorularının cevabı her zaman hazır.',
      },
      {
        title: 'Üyelere Açıklık',
        desc: 'Finansal raporları, kararları ve faaliyetleri üyelerle paylaşın. Güveni artırın.',
      },
      {
        title: 'Denetim Hazırlığı',
        desc: 'İç ve dış denetimler için gerekli tüm dokümantasyon sistem içinde. Hazırlık süresi minimum.',
      },
    ],
    image: '/assets/features/seffaflik.png',
  },
  {
    slug: 'otomatik-hatirlatma',
    icon: NotificationsActive,
    title: 'Otomatik Hatırlatma',
    shortDesc: 'Aidat ve etkinlik bildirimlerini otomatikleştirin.',
    color: '#84cc16',
    heroDesc: 'Manuel takip yükünden kurtulun. Akıllı otomasyon sistemi ile hatırlatmaları, bildirimleri ve rutin işlemleri otomatikleştirin.',
    benefits: [
      'Aidat vadesi hatırlatmaları',
      'Etkinlik bildirimleri',
      'Doğum günü mesajları',
      'Üyelik yenileme uyarıları',
      'Özel tarih hatırlatmaları',
      'Esnek zamanlama',
    ],
    details: [
      {
        title: 'Akıllı Hatırlatmalar',
        desc: 'Aidat vadesi yaklaşan üyelere otomatik hatırlatma. 7 gün önce, 3 gün önce, vade günü ve sonrası.',
      },
      {
        title: 'Etkinlik Otomasyonu',
        desc: 'Etkinlik öncesi hatırlatma, kayıt onayı ve teşekkür mesajları otomatik gönderilir.',
      },
      {
        title: 'Kişiselleştirilmiş Mesajlar',
        desc: 'Üye adı, aidat tutarı gibi dinamik alanlarla kişiselleştirilmiş mesajlar oluşturun.',
      },
    ],
    image: '/assets/features/otomatik-hatirlatma.png',
  },
];

export const getFeatureBySlug = (slug) => {
  return featuresData.find((f) => f.slug === slug);
};

export const getRelatedFeatures = (currentSlug, count = 3) => {
  return featuresData.filter((f) => f.slug !== currentSlug).slice(0, count);
};
